export default __webpack_public_path__ + "static/media/Stoll.04a35209.png";